import { Injectable, signal } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private deferredPrompt: any;

  // Using signals for easy reactive UI updates in Angular
  public showInstallButton = signal<boolean>(false);
  public platform = signal<'android' | 'ios' | 'other'>('other');

  constructor(private platformSvc: Platform) {
    this.init();
  }

  private init() {
    // 1. Detect Platform
    if (this.platformSvc.IOS) {
      this.platform.set('ios');
    } else if (this.platformSvc.ANDROID) {
      this.platform.set('android');
    }

    // 2. Listen for Android/Chrome Install Prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Update UI to show the install button
      if (!this.isStandalone()) {
        this.showInstallButton.set(true);
      }
    });

    // 3. For iOS, we check if we should show instructions
    // (iOS doesn't have the beforeinstallprompt event)
    if (this.platform() === 'ios' && !this.isStandalone()) {
      this.showInstallButton.set(true);
    }

    // Listen for successful installation
    window.addEventListener('appinstalled', () => {
      this.showInstallButton.set(false);
      this.deferredPrompt = null;
      console.log('PWA was installed');
    });
  }

  private isStandalone(): boolean {
    return (
      !!(window.navigator as any).standalone ||
      window.matchMedia('(display-mode: standalone)').matches
    );
  }

  public installPwa() {
    if (this.platform() === 'android' && this.deferredPrompt) {
      // Show the native install prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then(
        (choiceResult: { outcome: string }) => {
          if (choiceResult.outcome === 'accepted') {
            this.showInstallButton.set(false);
          }
          this.deferredPrompt = null;
        }
      );
    } else if (this.platform() === 'ios') {
      // Trigger a custom notification or alert with instructions for iOS
      alert(
        'To install Actively Booking: Tap the "Share" icon (square with up arrow) in Safari and select "Add to Home Screen".'
      );
    }
  }
}
